import {
    ADD_DEACTIVATION_BRANCH_ACTION,
    DELETE_DEACTIVATION_BRANCH_ACTION,
    MODIFY_DEACTIVATION_BRANCH_ACTION,
} from "../../../actionType";

export default function (state=[],action){
    switch (action.type) {
        case ADD_DEACTIVATION_BRANCH_ACTION:
            return [
                ...state,
                {
                    branchId:action.branchId,
                    branchCode: action.branchCode,
                    branchName: action.branchName,
                    effectiveDate:action.effectiveDate,
                    reason:action.reason,
                    key:action.key,
                }
            ];
        case MODIFY_DEACTIVATION_BRANCH_ACTION:
            const branchGridData = state;
            branchGridData[action.index] = action.branchInfo;
            return [
                ...branchGridData,
            ];
        case DELETE_DEACTIVATION_BRANCH_ACTION:
            state.splice(action.index,1);
            return [...state];
        default:
            return state;
    }
}